<template>
  <div class="-order-select-item">
    <span class="-order-select-item__order">{{ option.order }}</span>
    <span v-if="!isSimple" class="-order-select-item__delemiter"/>
    <span v-if="!isSimple" class="-order-select-item__startDate">{{ option.startDate }} </span>
    <span v-if="!isSimple" class="-order-select-item__dateDelemiter">~</span>
    <span v-if="!isSimple" class="-order-select-item__endDate">{{ option.endDate }}</span>
    <span
      class="-order-select-item__badge"
      :class="classes" >{{ option.label }}</span>
  </div>
</template>

<script>
// TODO: impl.
export default {
  name: 'SuiOrderSelectItem',
  props: {
    // 표기 대상인 옵션 리스트
    option: {
      type: Object,
      default: () => {},
    },
    // Simple 타입 여부: 날짜 제외, 차수와 status 만 표현되는 타입인지
    isSimple: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
    };
  },
  computed: {
    classes() { // 최상단 div에 적용될 class속성
      const classMap = {
        'P': 'inprogress',
        'N': 'notyet',
        'F': 'done',
        'R': 'reorder',
        'D': 'delay',
        '진행중': 'inprogress',
        '미진행': 'notyet',
        '완료': 'done',
        '재요청': 'reorder',
        '지연': 'delay',        
      };      
      const status = classMap[this.option.status];
      if (status) {
        return `-order-select-item__badge-${status}`;
      }
      return '';      
    },
  },  
  mounted() {
    // this.setStatus();
  },
};
</script>

<style scoped>
</style>
